import useGotoUrl from "helpers/useGotoUrl";
import { useEffect } from "react";

export default function GamePage({ gameId }) {
  const gotoUrl = useGotoUrl();
  useEffect(() => {
    // Carry the query string over, so entry links keep their utm params through this redirect.
    gotoUrl(`/game/${gameId}/overview${window.location.search}`, { replace: true });
  }, []);
  return null;
}
